import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Dot } from "./Section";

export default function LegalPage({ kicker, title, lede, updated, sections, testid }) {
  return (
    <div className="App" data-testid={testid}>
      <Navbar />
      <main>
        <section className="page-head">
          <div className="wrap legal-page">
            <h1><span className="label h1-kicker">{kicker}</span>{title}<Dot /></h1>
            {lede && <p className="lede" style={{ marginTop: 18 }}>{lede}</p>}
            <p className="updated">Last updated: {updated}</p>
            <div className="legal-list">
              {sections.map((s) => (
                <div key={s.h}>
                  <h2>{s.h}</h2>
                  {s.p && <p>{s.p}</p>}
                  {s.list && <ul>{s.list.map((li) => <li key={li}>{li}</li>)}</ul>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
